import { useMemo } from 'react';
import { components } from '@lifeserver/models/game-elements';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const DEFAULT_BASE_PATH = '/api';
const PREFIX = '/game-elements/v2';
const GET_GAME_ELEMENTS_PATH = `${PREFIX}/game-elements`;

type GetGameElementDto = components['schemas']['GetGameElementDTO'];
export type GameElementDto = components['schemas']['GameElementDTO'];

class GameElementsApi {
    getAllGameElements = async ({
        basePath = DEFAULT_BASE_PATH,
    } = {}): Promise<GetGameElementDto> => {
        const { data } = await axios.get<GetGameElementDto>(
            `${basePath}${GET_GAME_ELEMENTS_PATH}`,
        );

        return data;
    };

    getGameElement = async (
        id: string,
        { basePath = DEFAULT_BASE_PATH } = {},
    ): Promise<GameElementDto> => {
        const { data } = await axios.get<GameElementDto>(
            `${basePath}${GET_GAME_ELEMENTS_PATH}/${id}`,
        );

        return data;
    };
}

const useGameElementsApi = () => {
    return useMemo(() => new GameElementsApi(), []);
};

export const useGameElements = () => {
    const gameElementsApi = useGameElementsApi();

    return useQuery({
        queryKey: [GET_GAME_ELEMENTS_PATH],
        queryFn: () => gameElementsApi.getAllGameElements(),
    });
};
